const ScorecardQA = [
  {
    question: `What is the  <span id="plus-hook1">
              Scorecard?
              <a
                href="#scorecard1"
                className="toggle-link"
                aria-label="Read more about what is a scorecard"
              >
                <i className="fa-solid fa-circle-plus fa-lg"></i>
              </a>
            </span>`,
    answer: `
             <p>
            The Scorecard creates a baseline assessment of how a community is
            currently positioned through a set of questions that enables it to
            assess its wildfire resilience.
          </p>
          <p>
            The score enables measurement of a community's progress in moving
            forward, or the impact of retrograde steps needed - for example, how a
            community expands into the wildland urban interface (WUI).
          </p>`,
  },
  {
    question: ` Why do you need the <span id="plus-hook2">
              Scorecard?
              <a
                href="#scorecard2"
                className="toggle-link"
                aria-label="Read more about why do you need a scorecard?"
              >
                <i className="fa-solid fa-circle-plus fa-lg"></i>
              </a>
            </span>`,
    answer: ` <p>
            The Scorecard is intended to provide multiple benefits such as
            reduction in the likelihood and/or severity and extent of a potential
            wildfire occurring in your area; reduction in the risk of loss of life
            or injury, damage to property, loss of key services, harm to air and
            water quality in the community, to name just a few.
          </p>`,
  },
  {
    question: `How do you use the <span id="plus-hook3">
              Scorecard?
              <a
                href="#scorecard3"
                className="toggle-link"
                aria-label="Read more about how do you use a scorecard?"
              >
                <i className="fa-solid fa-circle-plus fa-lg"></i>
              </a>
            </span>`,
    answer: ` <p>
            The Scorecard is designed to encourage holistic thinking about all the
            elements of wildfire hazard, exposure, and vulnerability, at the
            property, community, and landscape scales.
          </p>
          <p>
            We suggest you start with what and who (Stakeholders) you have at
            hand, and use the results to embark on the communication, persuasion,
            and dialogue required to bring other stakeholders into alignment and
            into action.
          </p>`,
  },
  {
    question: `Who is the Scorecard <span id="plus-hook4">
              for?
              <a
                href="#scorecard4"
                className="toggle-link"
                aria-label="Read more about who is the scorecard for"
              >
                <i className="fa-solid fa-circle-plus fa-lg"></i>
              </a>
            </span>`,
    answer: ` <p>
            Anyone in the community with direct or contingent responsibility for
            wildfire risk reduction through mitigation, adaptation, event
            response, and post-event recovery.
          </p>
          <p>
            Also neighborhood or other concerned community members' groups,
            probably with expert assistance. You may not have responsibility or
            jurisdiction over issues raised in the scorecard but at least know
            that issues exist and be prepared to advocate for their resolution.
          </p>`,
  },
];

export { ScorecardQA };
